module.exports = __webpack_public_path__ + "img/static.e0c9eda3.jpg";